import type { Routes } from '@angular/router';

import { loadFeatureTranslations } from '#core/i18n/i18n-feature.loader';

export const LOGGED_IN_WHEELS_OF_FORTUNE_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#modules/wheels-of-fortune/views/logged-in/wheels-of-fortune/wheels-of-fortune-root.component').then(
                (m) => m.WheelsOfFortuneRootComponent
            ),
        resolve: {
            i18n: loadFeatureTranslations('wheels-of-fortune', { scope: 'logged-in' }),
        },
    },
];
